import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import createStyle from 'shared-utils/src/createStyle'


// This empty object will keep track of loaded icons
export const icons = {};

export const loader = {
    add(items) {
        Object.keys(items).forEach(name => {
            icons[name] = items[name];
        })
    },
}

const initStyles = createStyle(styles);

/**
 * Component for rendering vector icons
 */
export default function Icon({
    className,
    size,
    color,
    height,
    width,
    name,
    fill,
    illustration,
    ...props
}) {
    const classes = initStyles();
    const IconR = typeof name === 'string' ? icons[name] : name;

    let typeCls = classes.icon;
    if (fill) {
        typeCls = classes.iconFill;
    } else if (illustration) {
        typeCls = classes.illustration;
    }

    const cls = [
        className,
        typeCls,
        size && !height && !width ? classes[`icon-sz--${size}`] : '',
        color ? classes[`icon-cl--${color}`] : '',
      ].filter(c => c).join(' ').trim();
    const iconProps = {
        ...props,
        ...(height || width) && { style: { height, width } },
        className: cls,
    };

    !IconR && console.error(`Icon '${name}' not found`);

    return !!IconR && <IconR {...iconProps} />;
}

Icon.propTypes = {
    /**
     * Additional class names
     */
    className: PropTypes.string,
    /**
     * Name of the icon
     */
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.func
    ]).isRequired,
    /**
     * Icon size
     */
    size: PropTypes.string,
    /**
     * Icon color
     */
    color: PropTypes.string,
    /**
     * Icon height
     */
    height: PropTypes.string,
    /**
     * Icon width
     */
    width: PropTypes.string,
    /**
     * Icon should use fill instead of stroke
     */    
    fill: PropTypes.bool,
};

Icon.defaultProps = {
  className: '',
  size: 'm',
  color: '',
  height: '',
  width: '',
  fill: false,
};